import { useMemo } from 'react';

import { ACTION_OBJECT_TYPES } from 'actions/useActionsLibrary';

import PageHeader from 'components/global/PageHeader';
import DynamicList from 'components/list/DynamicList';
import { FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import { ENUMS, FINANCE } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';

/**
 * @author @muhammedburakak
 */

const BankTransferList = () => {
	const defaultSort = useMemo(() => [{ id: 'ID', desc: true }], []);

	const columns = useMemo(
		() => [
			{ Header: 'ID', accessor: 'ID', filterType: FilterType.number, width: 70, show: false },
			{
				Header: 'clientID',
				accessor: 'clientID',
				filterType: FilterType.number,
				show: false
			},
			{
				Header: 'clientName',
				accessor: 'clientName',
				filterType: FilterType.string
			},
			{
				Header: 'clientPlan',
				accessor: 'clientPlan',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.CLIENT_PLANS
			},
			{
				Header: 'createdDate',
				accessor: 'createdDate',
				filterType: FilterType.date,
				renderCell: ListComponents.DATETIME
			},
			{
				Header: 'approvalDate',
				accessor: 'approvalDate',
				filterType: FilterType.date,
				renderCell: ListComponents.DATETIME
			},
			{
				Header: 'vatNumber',
				accessor: 'vatNumber',
				filterType: FilterType.number,
				show: false
			},
			{
				Header: 'paymentReferenceCopy',
				accessor: 'paymentReferenceCopy',
				filterType: FilterType.string,
				renderCell: ListComponents.DOWNLOAD_FILE
			},
			{
				Header: 'invoiceLink',
				accessor: 'invoiceLink',
				filterType: FilterType.string,
				renderCell: ListComponents.DOWNLOAD_INVOICE
			},
			{
				Header: 'paymentID',
				accessor: 'paymentID',
				filterType: FilterType.number,
				show: false
			},
			{
				Header: 'transactionType',
				accessor: 'transactionType',
				filterType: FilterType.string
			},
			{
				Header: 'promoCode',
				accessor: 'promoCode',
				filterType: FilterType.string,
				show: false
			},
			{
				Header: 'amount',
				accessor: 'amount',
				filterType: FilterType.float,
				renderCell: ListComponents.CURRENCY
			},
			{
				Header: 'requestedAmount',
				accessor: 'requestedAmount',
				filterType: FilterType.float,
				renderCell: ListComponents.CURRENCY
			},
			{
				Header: 'paidPrice',
				accessor: 'paidPrice',
				filterType: FilterType.float,
				renderCell: ListComponents.CURRENCY
			},
			{
				Header: 'description',
				accessor: 'description',
				filterType: FilterType.string
			},
			{
				Header: 'transactionDate',
				accessor: 'transactionDate',
				filterType: FilterType.date,
				renderCell: ListComponents.DATETIME
			},
			{
				Header: 'status',
				accessor: 'status',
				renderCell: ListComponents.STATUS,
				filterType: FilterType.enumMulti,
				enumName: ENUMS.CREDIT_TRANSACTION_STATUS
			},
			{
				Header: 'currency',
				accessor: 'currency',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.CURRENCY
			}
		],
		[]
	);

	return (
		<div>
			<PageHeader
				lordIcon="https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/payments-icon.json.gz"
				title="bankTransfer"
			/>

			<DynamicList
				id={DYNAMICLISTS.BANK_TRANSFER}
				columns={columns}
				fetchUrl={FINANCE.GET_BANK_TRANSFER_LIST}
				exportName="bankTransfer"
				actionObjectType={ACTION_OBJECT_TYPES.OTHER}
				defaultSort={defaultSort}
			/>
		</div>
	);
};

export default BankTransferList;
